import React from "react";
import "./Footer.css";
import Logo from "./../images/logo.png";
import { Link } from "react-router-dom";
import whatsapp from "./../images/whatspp.webp";
import phone from "./../images/phone.webp";
const Footer = () => {
  return (
    <div>
      <div className="footer">
        <div className="container">
          <div className="row">
            <div className="col">
             <Link to="https://www.vendorascmsoftware.com/" target="_blank"> <img src={Logo} alt="logo" /></Link>
              <p>
                Dealing with multiple vendors for different needs is not so
                easy, for this we have to leverage on a vendor management tool
                that helps drive more value out of vendor relationships.
              </p>
            </div>
            <div className="col">
              <h6>Product Features</h6>
              <ul>
                <li>
                  <Link to="https://www.vendorascmsoftware.com/sap-erp-integration/" target="_blank">SAP ERP Integration </Link>
                </li>
                <li>
                  <Link to="https://www.vendorascmsoftware.com/vendor-on-boarding/" target="_blank">Vendor On-boarding </Link>
                </li>
                <li>
                  <Link to="https://www.vendorascmsoftware.com/features/rfq/" target="_blank">Request For Quote</Link>
                </li>
                <li>
                  <Link to="https://www.vendorascmsoftware.com/manage-purchase-orders/" target="_blank">Manage Purchase Orders</Link>
                </li>
                <li>
                  <Link to="https://www.vendorascmsoftware.com/asn-advance-shipping-notice/" target="_blank"> Advance Shipping Notice</Link>
                </li>
                <li>
                  <Link to="https://www.vendorascmsoftware.com/grn/" target="_blank">Goods Receipt Note</Link>
                </li>
              </ul>
            </div>
            <div className="col">
              <h6>Quick Links</h6>
              <ul>
           
                <li>
                  <Link to="https://www.vendorascmsoftware.com/features/" target="_blank">Product Features</Link>
                </li>
                <li>
                  <Link to="https://www.vendorascmsoftware.com/products/key-benefits/" target="_blank">Key Benefits </Link>
                </li>
                <li>
                  <Link to="https://www.vendorascmsoftware.com/return-on-investment/" target="_blank">ROI Calculator</Link>
                </li>
                <li>
                  <Link to="https://www.vendorascmsoftware.com/webinars/" target="_blank"> Webinars </Link>
                </li>
                <li>
                  <Link to="https://www.vendorascmsoftware.com/products/product-demo/" target="_blank">Get Free Demo</Link>
                </li>
              </ul>
            </div>
            <div className="col">
              <h6>Coimbatore</h6>
              <p>
            
No:1247 Trichy Road, <br/>
Coimbatore - 641 045, <br/>
Tamil Nadu, India.

              </p>
              <ul className="footer-detail">
                <li>
                  Email id : <Link to="mailto:info@vendorascmsoftware.com">info@vendorascmsoftware.com</Link>
                </li>
                <li>
                  Mobile No :<br/> <Link to="tel:+91-9361663950">+91-9361663950</Link><br/><Link to="tel:+91-9361663940">+91-9361663940</Link>
                </li>
              </ul>
            </div>
            <div className="col">
              {/* <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d979.1369726234233!2d76.98630864568754!3d10.99745812485194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba859bf59b00001%3A0x7304ccc640b59019!2sANGLER%20Technologies!5e0!3m2!1sen!2sin!4v1694664969503!5m2!1sen!2sin"
                width="110%"
                height="280"
                style={{ border: "0" }}
                allowFullScreen
                loading="lazy"
                title="Google Maps"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe> */}
                <h6>Chennai</h6>
              <p>
            
              AP 852/59, 1st Floor, H Block, 2nd <br/>Street, 11th Main Rd, Anna Nagar,<br/> Chennai-600 040, Tamil Nadu.
            </p>
              <ul className="footer-detail">
                <li>
                  Email id : <Link to="mailto:info@vendorascmsoftware.com">info@vendorascmsoftware.com</Link>
                </li>
                <li>
                  Mobile No :<br/> <Link to="tel:+91-9381066669">+91-9381066669</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="social-media">
            <ul>
              <Link to="https://www.linkedin.com/company/vendora-scm-software/?originalSubdomain=in" target="blank">
                <i className="fa-brands fa-linkedin"></i>
              </Link>
              <Link to="https://www.facebook.com/vendorascm" target="blank">
                <i className="fa-brands fa-square-facebook"></i>
              </Link>
              <Link to="https://twitter.com/i/flow/login?redirect_after_login=%2FVendorascm" target="blank">
                <i className="fa-brands fa-square-x-twitter"></i>
              </Link>
              <Link to="https://www.youtube.com/watch?v=YgY4TRr2ve8" target="blank">
                <i className="fa-brands fa-square-youtube"></i>
              </Link>
            </ul>
          </div>
        </div>
      </div>
      <div className="copy-rights">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <p>Copyright © ANGLER Technologies 2026. All rights reserved.</p>
            </div>
            <div className="col-md-6">
              <ul>
                <li><Link to="https://www.vendorascmsoftware.com/privacy-policy/" target="_blank">Privacy Policy</Link></li>
               
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="quick-container">
        <ul className="quick">
          <li>
        
            <Link to="tel: +91-9361663950">
              <img src={phone} alt="1" />
              <p>Call <br /> +91-9361663950</p>
            </Link>
          </li>
          <li>
      
            <Link to="https://api.whatsapp.com/send?phone=919361663950 "
              target="_blank"
            >
              <img src={whatsapp} alt="1" />
              <p>
                Whatsapp
                <br />
                +91-9361663950
              </p>
            </Link>
          </li>
        </ul>
      </div>
      <div className=" quick-container1">
        <ul className=" quick1">
        <Link to="https://www.vendorascmsoftware.com/return-on-investment/" target="_blank">   <li>  
            <i className="fa-solid fa-calculator"></i>
            <p>ROI Calculator</p>
          </li></Link>
          <Link to="mailto:info@vendorascmsoftware.com"> <li>
          <i className="fa-regular fa-envelope"></i>
             <p>Get Quick Quote</p>
          </li></Link>
        </ul>
      </div>
    </div>
  );
};

export default Footer;
